import { ReturnRequestDto } from "@babackapp/private-api-client/types";

type GetReturnRequestRefundPaidShippingCostOptions = {
  refundReturnRequest: ReturnRequestDto;
};

export function getReturnRequestRefundPaidShippingCost({
  refundReturnRequest,
}: GetReturnRequestRefundPaidShippingCostOptions): number {
  const { financial_informations: financialInfo } = refundReturnRequest;
  const { return_shipping_paid: returnShippingPaid } = financialInfo;

  /**
   * If the items are not refundable, we don't need
   * to calculate the return shipping cost
   */
  if (returnShippingPaid?.method !== "refund") return 0;

  /**
   * If the presentment amount is less than or equal to 0
   * TODO: document
   */
  if (returnShippingPaid.presentment_amount <= 0) return 0;

  /**
   * If the return shipping cost is already paid
   */
  if (returnShippingPaid.done) return 0;

  return returnShippingPaid.presentment_amount;
}
